import { MainColor } from '../../palette';

export const getModalThemeConfig = () => {
  return {
    default: {
      background: 'white95' satisfies MainColor as MainColor,
      content: 'white95' as MainColor,
      text: 'navy95' as MainColor,
      label: 'coolGrey60' as MainColor,
    },
  };
};

export type ModalThemeConfig = ReturnType<typeof getModalThemeConfig>;
